<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Dialog</mat-panel-title>
  </mat-expansion-panel-header>
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <dl fxFlex="45" class="settings-list">
        <dt>Fælles "læst" markering</dt>
        <dd>{{value.shared_reader ? 'Ja' : 'Nej'}}</dd>
        <dt>{{'grant-admin.dialog-settings.thread_type.label' | translate}}</dt>
        <dd>{{('grant-admin.dialog-settings.thread_type.' + value.thread_type) | translate}}</dd>
      </dl>
      <mat-divider [vertical]="true"></mat-divider>
      <dl fxFlex="45" class="settings-list">
        <dt>Intern afsendere</dt>
        @if (!value.internal_senders.length) {
          <dd>Kun oprettede brugere.</dd>
        }
        @for (m of value.internal_senders; track m) {
          <dd>{{m}}</dd>
        }
      </dl>
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form">
      <div fxLayout="row" fxLayoutAlign="space-between" class="mb-3">
        <div fxFlex="45" fxLayout="column">
          <p>Hvis aktiveret markeres beskeder som læst, hvis en bruger har læst beskeden.</p>
          <mat-checkbox ngDefaultControl formControlName="shared_reader">Brug fælles "læst" markering</mat-checkbox>
          <div class="my-3"></div>
          <label>{{'grant-admin.dialog-settings.thread_type.label' | translate}}</label>
          <mat-radio-group formControlName="thread_type" class="thread-type-radio-group" ngDefaultControl>
            @for (type of dialogThreadTypes; track type) {
              <mat-radio-button [value]="type" class="thread-type-radio-button">
                {{('grant-admin.dialog-settings.thread_type.' + type) | translate}}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
        <div fxFlex="45" fxLayout="column" formArrayName="internal_senders">
          <p>Indkommende beskeder til sagen send fra en bruger i fonden opfattes automatisk som "interne", dvs. de ikke bliver vist for ansøger. Det er muligt at tilføje yderligere interne afsendere.</p>
          @for (_ of internalSenders.controls; track _; let i = $index) {
            <div fxLayout="row" fxLayoutAlign="start center">
              <mat-form-field >
                <mat-label>Afsender e-mail</mat-label>
                <input
                  type="email"
                  matInput
                  [formControl]="internalSenderAt(i)"
                  />
              </mat-form-field>
              <button
                mat-icon-button
                matTooltip="Slet intern afsender"
                (click)="doRemoveInternalSender(i)"
                ><mat-icon>delete</mat-icon></button>
              </div>
            }
            <div>
              <button
                mat-stroked-button

                matTooltip="Tilføj intern afsender"
                (click)="doAddInternalSender()"
              >Tilføj intern afsender</button>
            </div>
          </div>
        </div>
      </form>
    }
    <mat-action-row>
      @if (form.disabled) {
        <button mat-flat-button (click)="doEdit()">Rediger</button>
      }
      @if (form.enabled) {
        <div>
          <button mat-stroked-button (click)="doCancel()">Fortryd</button>
          <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
        </div>
      }
    </mat-action-row>
  </mat-expansion-panel>
